import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(theme => ({
	titleText: {
		fontSize: "32px",
		lineHeight: "24px",
		color: colors.gray[700]
	},
	subtitleText: {
		textTransform: "uppercase"
	},
	textContainer: {
		overflow: "hidden",
		textOverflow: "ellipsis",
		paddingLeft: theme.spacing(1)
	},
	nameText: {
		fontWeight: 600,
		fontSize: "16px"
	},
	editButton: {
		marginLeft: theme.spacing(2)
	},
	noTeamListed: {
		textTransform: "uppercase",
		marginTop: "65px",
		marginBottom: "65px"
	},
	iconButton: {
		background: colors.gray[100],
		opacity: 0.8,
		borderRadius: "8px",
		gap: "8px",
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor(colors.gray[200])
		},
		width: "64px",
		height: "64px",
		color: colors.gray[700],
		fontSize: "20px"
	},
	teamCard: {
		padding: "8px"
	},
	createdAtText: {
		flex: 1,
		color: colors.gray[500]
	},
	createdAt: {
		opacity: 0.85,
		fontSize: "16px",
		fontWeight: 300
	}
}))

export default useStyles
